import { useTranslation } from 'react-i18next';

export default function ParkingLocationRule() {
    const { t } = useTranslation();
    return (
        <div className="space-y-[calc(8*var(--vh-unit))]">
            <div className="text-[var(--color-text-sub01)] text-[calc(16*var(--vh-unit))] font-medium leading-[calc(26*var(--vh-unit))] tracking-[calc(-0.32*var(--vh-unit))]">
                <p>{t('parking.rules.locationRule1')}</p>
                <p>{t('parking.rules.locationRule2')}</p>
                <p>{t('parking.rules.locationRule3')}</p>
            </div>
        </div>
    );
}
